import React from "react";
import "../../Assessts/Styles/AboutUs.scss";
import AUB from "../../Assessts/Images/AboutUs/AUB.png";
import { Row, Col } from "react-bootstrap";

import IOText from "../../ReUableComponents/ImageOntext";
import AboutUs from "../../Assessts/Images/Home/AboutUs.png";

import Scholarships from "../../Assessts/Images/Home/Scholarships.svg";
import AScholarships from "../../Assessts/Images/Home/AScholarships.svg";
import ENCP from "../../Assessts/Images/Home/ENCP.svg";

import OVM from "../../Assessts/Images/AboutUs/OVM.png";

import AScholarship from "../../Assessts/Images/AboutUs/A-Scholarships.png";
import ANCP from "../../Assessts/Images/AboutUs/A-NCP.png";

import Vision from "../../Assessts/Images/AboutUs/Vission.png";
import Mission from "../../Assessts/Images/AboutUs/Mission.png";
import Star from "../../Assessts/Images/AboutUs/Star.svg";
const CBLerning = () => {
    const DetailsNCF = [
        { Name: "Scholarships", value: "11,000+", icon: Scholarships },
        { Name: "Awarded in scholarships", value: "₹55+ Cr", icon: AScholarships },
        { Name: "Enrolled in NCP", value: "2,50,000+", icon: ENCP },
    ]
    return (<div className="AboutUs-MainDiv mt-2">
        {/* style={{ position: "relative", left: "-90%" }} */}
        <IOText Image={AUB} Alt="EMpower" Text={<div className="Text-MainDiv ">
            <div></div>
            <div className="w-100">Powering <span style={{ color: "#F7D670" }}>Educational Success</span> with <span style={{ color: "#F7D670" }}>   Scholarships</span> and <span style={{ color: "#F7D670" }}>Competency Growth</span></div>
            <div className="mt-2 Text-Content" >
                <span style={{ color: "#F7D670" }}> Home </span>   &gt;     About Us
            </div>
        </div>} />

        <div className="dflex gap-5 JCCenter mt-5 mb-4 NCF-DetailsMainDiv p-0">
            {DetailsNCF.map((item) => (
                <div className="dflex flexd-column alignitems gap-2 NCFDetails">
                    <span>{item?.value}</span>
                    <span>{item?.Name}</span>
                    <span className="NCFDetails-icon"><img src={item?.icon} alt={item?.Name} /></span>
                </div>
            ))}
        </div>
        <div style={{position:"relative"}}>
            <div className="dflex A-Aboutus" >
                <div className="">
                    <span className="Web-MainHeading" style={{ justifyContent: "flex-start" }}>About Us</span>
                    <p>North South Foundation (NSF) is a non-profit organization based in Hyderabad, founded in 2004, dedicated to promoting educational excellence among economically disadvantaged students in India.</p>
                    <div className="dflex alignitems gap-2 mt-2 p-0"> <p><b>NSF Scholarship Program (NSP)  </b></p></div>
                    <p > North South Foundation provides merit cum need based scholarships to undergraduate students entering engineering, medicine, dental, agriculture, nursing, pharmacy, diploma courses. The program supports students’ academic journey and fosters their potential. North South Foundation has provided scholarships worth Rs. 55 Crores to nearly 11,000 scholars in the last decade.</p>
                    <div className="dflex alignitems gap-2 mt-2 p-0"> <p><b>NSF Competency Program (NCP)</b></p></div>
                    <p >The North South Foundation Competency Program (NCP)  Initiative offers high quality competency-based assessments aligned to the curriculum at no cost to government schools across India. The initiative uses an online platform, detailed dashboards, and a high-quality question bank to provide comprehensive feedback and support. Over 250,000 children are registered to participate in the NCP assessments.</p>
                </div>
                <div className="dflex alignitems">
                    <img src={AboutUs} alt="About Us" /></div>
            </div>

            <div className="dflex JSBetween OURVM">
                <div>
                    <span className="Web-SubHeading">Our Vision</span>
                    <p>Ensuring equitable education access, nurturing empathetic leaders, and uniting volunteers to strengthen communities everywhere globally.</p>
                </div>

                <div>
                    <span className="Web-SubHeading">Our Mission</span>
                    <p>Advancing excellence in education, empathy, and social entrepreneurship to create inclusive, innovative, and compassionate societies.</p>
                </div>
            </div>
        </div>

        {/* <div className="dflex OURVM mt-4" >
            <div className="dflex alignitems JCCenter"> <img src={OVM} alt="Our Vision / Mission" className="Our-Img" /></div>

            <div className="dflex flexd-column JCCenter">
                <div className="Card mb-3">
                    <div className="Web-SubHeading p-0 dflex gap-2 alignitems"><img src={Vision} alt="Our Vision" style={{ width: "25px", height: "25px" }} /> Our Vision</div>
                    <p> <img src={Star} alt="Star" />Excellence in education, empathy, and social entrepreneurship.</p>

                </div>
                <div className="Card">
                    <div className="Web-SubHeading p-0 dflex gap-2 alignitems"><img src={Mission} alt="Our Mission" style={{ width: "25px", height: "25px" }} />Our Mission</div>
                    <p><img src={Star} alt="Star" />Provide every child with opportunity and equity to educational
                        access</p>
                    <p><img src={Star} alt="Star" />Empower every child to be an empathetic and holistic leader</p>
                    <p><img src={Star} alt="Star" />Provide a platform for volunteers to come together to support
                        their Communities</p>
                </div>
            </div>

        </div> */}
    </div>)
}
export default CBLerning;